import React, { FC, useCallback, useState } from "react";
import { ButtonProps, Dialog, Input } from "@xapp/components";

import { BasicIntegrationCard, IntegrationCardProp } from "./BasicIntegrationCard";

export interface ContractorAppointmentsConnectionProps {
    integration: "contractor_appointments";
    campaignId: string;
    campaignKey: string;
    defaultTrade?: string;
}

export interface ContractorAppointmentsIntegrationCardProps extends IntegrationCardProp {
    campaignId?: string;
    campaignKey?: string;
    defaultTrade?: string;

    onConnect?(props: ContractorAppointmentsConnectionProps): void;
}

export const ContractorAppointmentsIntegrationCard: FC<ContractorAppointmentsIntegrationCardProps> = (props) => {

    const { checked, disabled, isLinked, isActive, onConnect, onDisconnect } = props;

    const [campaignId, setCampaignId] = useState<string>(props.campaignId || "");
    const [campaignKey, setCampaignKey] = useState<string>(props.campaignKey || "");
    const [defaultTrade, setDefaultTrade] = useState<string>(props.defaultTrade || "");
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const handleContractorAppointmentsClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();

        if (typeof checked === "boolean") {
            if (typeof props.onClick === "function") {
                props.onClick(e);
            }
        } else {
            // pop up modal
            setShowDialog(true);
        }
    };

    const handleConnectContractorAppointments = useCallback(() => {
        if (typeof onConnect === "function") {
            onConnect({
                integration: "contractor_appointments",
                campaignId,
                campaignKey,
                defaultTrade: defaultTrade || undefined
            });
            setShowDialog(false);
        }
    }, [onConnect, campaignId, campaignKey, defaultTrade]);

    const handleDisconnectContractorAppointments = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const actions: ButtonProps[] = [
        {
            label: "Close",
            variation: "secondary",
            onClick: () => { setShowDialog(false) }
        }
    ];

    if (typeof onConnect === "function") {
        actions.push({
            label: "Connect",
            variation: "primary",
            disabled: !campaignId || !campaignKey,
            onClick: handleConnectContractorAppointments
        })
    }

    return (
        <>
            <BasicIntegrationCard
                checked={checked}
                disabled={disabled}
                imageUrl="/img/integrations/contractor-appointments/contractor-appointments-icon-large.png"
                text="Contractor Appointments"
                href={() => "/integrations/contractor_appointments"}
                onClick={handleContractorAppointmentsClick}
                isLinked={isLinked}
                isActive={isActive}
                onDisconnect={typeof onDisconnect === "function" ? handleDisconnectContractorAppointments : undefined}
            />
            <Dialog
                active={showDialog}
                actions={actions}
                title="Contractor Appointments Setup"
                onClose={() => { setShowDialog(false) }}
            >
                <p>Enter your Contractor Appointments campaign details below.</p>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Input label="Campaign ID" value={campaignId} onChange={setCampaignId} />
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Input label="Campaign Key" value={campaignKey} onChange={setCampaignKey} />
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Input label="Default Trade (Optional)" value={defaultTrade} onChange={setDefaultTrade} />
            </Dialog>
        </>
    );
}
